export const CLIPPER_SET = 'CLIPPER_SET';
export const CLIPPER_CLEAR = 'CLIPPER_CLEAR';

export const CLIPPER_OPERATION_COMPLETE = 'CLIPPER_OPERATION_COMPLETE';
